 
  export const headers = {
    initialHeaders: [
      { title: "Ubicación", field: "location", child: null },
      { title: "Perfil del cargo", field: "nameProfilePosition", child: 'denomination' },
      { title: "Rol del cargo", field: "rolePosition", child: null },
      { title: "Jefe inmediato", field: "immediateBoss", child: 'denomination' },
      { title: "Estado", field: "status", child: null },
    ],
    otherHeaders: [
      { title: "Misión del cargo", field: "chargeMission", child: null},
      { title: "Cargos bajo supervisión", field: "chargesUnderSupervision", child: 'denomination' },
      { title: "Descripción", field: "attribute", child: null },

    ]
    
  };
  